import React, { useEffect } from 'react'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getResourceAuthorization as getResourceAuthorizationSelector } from '@verzekeringapp-mono/shared/src/state/selectors/resource_authorization'
import { getCombiCollectionAmount } from '@verzekeringapp-mono/shared/src/state/selectors/policies'
import useResourceAuthorization from '@verzekeringapp-mono/shared/src/hooks/use_resource_authorization'

const CombiPolicyDetailScreen = () => {
  const combiCollectionAmount = useAppSelector(getCombiCollectionAmount)
  const resourceAuthorization = useAppSelector(getResourceAuthorizationSelector)
  const { getResourceAuthorization } = useResourceAuthorization()

  useEffect(() => {
    getResourceAuthorization()
  }, [])

  return (
    <ScreenWrapper>
      <div className='rounded-lg bg-surface-page p-8'>
        <div className='flex justify-between items-start mb-8 flex-wrap gap-4'>
          <div className='flex-col flex-1'>
            <p>Betaaltermijn:</p>

            <p>{resourceAuthorization?.relationInfo?.paymentPeriod}</p>
          </div>

          <div className='flex-col flex-1'>
            <p>Combinummer:</p>

            <p>{resourceAuthorization?.combiNumber}</p>
          </div>

          <div className='flex-col flex-1'>
            <p>Ingangsdatum:</p>

            <p>{resourceAuthorization?.relationInfo?.combiStartingDate}</p>
          </div>

          {!!resourceAuthorization?.relationInfo?.combiPackageDiscount && (
            <div className='flex-col flex-1'>
              <p>Combikorting:</p>

              {Intl.NumberFormat('nl-NL', {
                style: 'percent'
              }).format(Number(resourceAuthorization.relationInfo.combiPackageDiscount) / 100)}
            </div>
          )}

          <div className='flex-col flex-1'>
            <p>Status:</p>

            <p>{resourceAuthorization?.relationInfo?.combiStatus}</p>
          </div>

          {resourceAuthorization?.relationInfo && (
            <div className='flex-col flex-1'>
              <p>Totaal bedrag:</p>

              <p>
                {Intl.NumberFormat('nl-NL', {
                  style: 'currency',
                  currency: 'EUR'
                }).format(Number(combiCollectionAmount))}
              </p>
            </div>
          )}
        </div>

        <a
          href={resourceAuthorization?.relationInfo?.combiPolicyCondition.url}
          target='_blank'
          className='text-text-brand'
          rel='noreferrer'
        >
          Algemene voorwaarden
        </a>
      </div>
    </ScreenWrapper>
  )
}

export default CombiPolicyDetailScreen
